import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { setAuthSession } from '../../utils/auth-storage';

import './login.css';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState();

  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const response = await axios.create().post(
        `/api/login/`,
        {
          username,
          password,
        }
      );
      setAuthSession({
        accessToken: response.data.access,
        refreshToken: response.data.refresh,
        username,
      });
      setError(null);

      setSuccessMessage(`Welcome, ${username}!`);
      const intendedPath = sessionStorage.getItem('intendedPath') || '/';
      sessionStorage.removeItem('intendedPath');
      setTimeout(() => {
        setSuccessMessage('');
        navigate(intendedPath, { replace: true });
      }, 400);
    } catch (err) {
      setError('Invalid credentials. Please try again.');
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    login(username, password);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo-container">
          <img
            alt="JozaniAI logo"
            className="login-logo"
            src={require('./../../assets/jozani-logo.png')}
          />
        </div>
        <h2 className="login-title">Log In to Continue</h2>
        {successMessage && (
          <div className="success-message" role="status" aria-live="polite">
            {successMessage}
          </div>
        )}
        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}
        <form
          onSubmit={handleLogin}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div className="input-group">
            <label className="sr-only" htmlFor="login-username">
              Username
            </label>
            <input
              id="login-username"
              name="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
            />
          </div>
          <div className="input-group">
            <label className="sr-only" htmlFor="login-password">
              Password
            </label>
            <input
              id="login-password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
          </div>
          <div className="login-btn-container">
            <button type="submit" className="login-btn">
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
